// Features.jsx — "Everything You Need" section, redesigned as a clean,
// on-brand feature grid (one concise tile per capability).
import React from 'react';
import {
    FiGlobe,
    FiBarChart2,
    FiTruck,
    FiCreditCard,
    FiShoppingBag,
    FiShield,
} from 'react-icons/fi';
import styles from './Features.module.css';

const features = [
    {
        icon: FiGlobe,
        title: 'নিজের অনলাইন স্টোর',
        desc: 'কাস্টম ডোমেইন ও ফ্রি SSL, মোবাইল অপটিমাইজড এবং সুপার ফাস্ট হোস্টিং — কোনো কোডিং ছাড়াই।',
    },
    {
        icon: FiBarChart2,
        title: 'মার্কেটিং ও পিক্সেল',
        desc: 'ফেসবুক পিক্সেল, কনভার্সন API, গুগল অ্যানালিটিক্স ও ট্যাগ ম্যানেজার এবং SMS মার্কেটিং।',
    },
    {
        icon: FiTruck,
        title: 'অর্ডার ও কুরিয়ার',
        desc: 'অ্যাডভান্সড অর্ডার ম্যানেজমেন্ট — Steadfast, Pathao ও RedX-এ এক ক্লিকে অর্ডার এন্ট্রি।',
    },
    {
        icon: FiCreditCard,
        title: 'পেমেন্ট গেটওয়ে',
        desc: 'বিকাশ, নগদ, রকেট, SSLCommerz এবং ক্যাশ অন ডেলিভারি।',
    },
    {
        icon: FiShoppingBag,
        title: 'প্রোডাক্ট ও সেলস',
        desc: 'ভ্যারিয়েশন, প্রোডাক্ট ভিডিও, সহজ চেকআউট, কুপন ও হট ডিল দিয়ে বেশি বিক্রি।',
    },
    {
        icon: FiShield,
        title: 'ফ্রড প্রোটেকশন ও রিপোর্ট',
        desc: 'ফ্রড কাস্টমার ব্লক, ডেলিভারি রেপুটেশন এবং প্রফিট/লস ও বিক্রির রিপোর্ট।',
    },
];

const Features = () => {
    return (
        <div className={styles['features-container']}>
            <div className={styles['features-header']}>
                <h2 className={styles['features-heading']}>
                    ব্যবসা বড় করার সব টুল এক জায়গায়
                </h2>
                <p className={styles['features-subtitle']}>
                    স্টোর থেকে মার্কেটিং, অর্ডার থেকে ডেলিভারি — আপনার দরকারি সবকিছু একটি প্ল্যাটফর্মেই।
                </p>
            </div>
            <div className={styles['features-grid']}>
                {features.map((f, i) => (
                    <div className={styles['feature-tile']} key={i}>
                        <div className={styles['feature-icon']}>
                            <f.icon />
                        </div>
                        <h3 className={styles['feature-title']}>{f.title}</h3>
                        <p className={styles['feature-desc']}>{f.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Features;
